import React, { useEffect, useState } from "react";
import Layout from "../layouts/Layout";
import { connect } from "react-redux";
import { Container } from "react-bootstrap";

const Terms = ({ apiData, profile }) => {
  return (
    <Layout>
      <Container className="terms">
        <h2 className="mb-5">Terms & Conditions</h2>
        <div className="inner_page_warp terms_condtion_wrp">
          {" "}
          <p>
            <strong>1. Introduction</strong>
          </p>{" "}
          <p>
            These Terms of Service (the “Terms”) are intended to make you aware
            of your rights and responsibilities with respect to your access to
            and use of the Open Bonnet Mobile Application (the “App”) and any
            related website or software applications (collectively known as “OB
            Platform”) including but not limited to delivery of services,
            products and information via OB Platform whether existing now or in
            the future that links to the Terms (collectively, the “Services”).
          </p>{" "}
          <p>
            These Terms are effective for all existing and future OB Platform
            users. Please read these Terms carefully. By downloading, accessing
            or using the OB Platform, you are agreeing to these Terms and
            entering into a legally binding agreement with OB Tech-FZCO and/or
            its affiliates (hereinafter collectively referred to as “OB”). You
            may not use the Services if you do not accept the Terms or are
            unable to be bound by the Terms. Your use of the OB Platform is at
            your own risk, including the risk that you might be exposed to
            content that is objectionable, or otherwise inappropriate.
          </p>{" "}
          <p>
            These Terms comprise the entire agreement between you and the
            Company and supersedes all prior or contemporaneous negotiations,
            discussions or agreements, whether written or oral, between the
            parties regarding these Terms of Service.
          </p>{" "}
          <p>
            <strong>2. Definitions</strong>
          </p>{" "}
          <ol type="a" className="nitro-offscreen">
            {" "}
            <li>
              <strong>
                <b>User</b>
              </strong>
              <br /> <strong> “User”</strong> means a person who accesses or
              uses the Service/Application/OB Platform.
            </li>{" "}
            <li>
              <strong>
                <b>Content</b>
              </strong>
              <br /> <strong>“User Content”</strong> means Content that a User
              posts, uploads, publishes, submits or transmits to be made
              available through the Serviceor Application in connection with the
              Services.
              <strong>
                <b>“OB Content” </b>
              </strong>
              means content that OB creates and make available in connection
              with the Services associated with your account andall other
              elements and components of the Services excluding Your Content and
              Third Party Content.
              <strong>
                <b>“Third Party Content” </b>
              </strong>
              means content that comes from parties other than OB or its users
              and is available on OB Platform.
            </li>{" "}
          </ol>{" "}
          <p className="nitro-offscreen">
            <strong>3. Membership Terms</strong>
          </p>{" "}
        </div>{" "}
        <ol className="nitro-offscreen">
          {" "}
          <li>
            User hereby represents and warrants that he/she is at least eighteen
            (18) years of age or above and is fully able and competent to
            understand and agree the terms, conditions, obligations,
            affirmations, representations, and warranties set forth in these
            Terms.
          </li>{" "}
          <li>
            No individual may register as a member of the OB Platform more than
            once.
          </li>{" "}
          <li>
            For registration as a member of the OB Platform, its mandatory to
            provide certain personal information like name, age, contact details
            subsequent to which User’s login credentials shall be created.
          </li>{" "}
          <li>
            Compliance with all laws and regulations in the country in which
            User live when User access and use the Services is mandatory. User
            agree to use the Services only in compliance with these Terms and
            applicable law, and in a manner that does not violate our legal
            rights or those of any third party(ies).
          </li>{" "}
        </ol>{" "}
        <p className="nitro-offscreen">
          <strong>4. User undertakes, represents and warrants that</strong>
        </p>{" "}
        <ol className="nitro-offscreen">
          {" "}
          <li>
            User will inform OB of any postings, items or transactions which
            appear to be in violation of these Terms of Service.
          </li>{" "}
          <li>
            User shall comply with all applicable domestic and international
            laws and regulations regarding and relating to User’s use of OB
            Platform.
          </li>{" "}
          <li>
            Information User provides on OB Platform in respect of services User
            wish to procure shall be as accurate as reasonably possible.
          </li>{" "}
          <li>
            User will not disclose his/her contact details including but not
            limited to phone numbers, addresses, or email addresses to workshops
            or vendors on OB, or anywhere on the Site including the Feedback
            area, discussion forum or through any feature of OB Platform
            intended to bypass role of OB, unless required as per the OB
            Platform processes or workflow.
          </li>{" "}
        </ol>{" "}
        <p className="nitro-offscreen">
          <strong>5. Termination of User’s access to the Services</strong>
        </p>{" "}
        <ol className="nitro-offscreen">
          {" "}
          <li>
            User can deactivate his/her Open Bonnet account at any time by
            contacting us via “Contact Us” link in the App or OB website.
          </li>{" "}
          <li>
            We may terminate User’s use of the Services and deny user access to
            the Services in our sole discretion for any reason or no reason,
            including but not limited to violation of these Terms or if OB
            believes (in its sole discretion) that User’s actions may cause
            legal liability for himself, other users or to OB.
          </li>{" "}
          <li>
            User agree that any termination of User’s access to the Services may
            be affected without prior notice, and acknowledge and agree that we
            may immediately deactivate or delete User’s account and all related
            information.
          </li>{" "}
          <li>
            If User uses the Services in violation of these Terms, we may, in
            our sole discretion, retain all data collected from User’s use of
            the Services.
          </li>{" "}
          <li>
            Further, User agrees that we shall not be liable to User or any
            third party for the discontinuation or termination of User’s access
            to the Services.
          </li>{" "}
        </ol>{" "}
        <p className="nitro-offscreen">
          Notwithstanding the foregoing, if User breaches these Terms, OB
          reserves the right to recover any amounts due and owing by User to OB
          or any losses and damages caused by User to OB and to take such steps
          including legal action and/or the initiation of criminal proceedings
          against User as OB in its sole discretion deems necessary. Our failure
          to act with respect to a breach by User or others does not constitute
          a waiver of OB’s right to take any actions with respect to that, or
          subsequent or similar breaches.
        </p>{" "}
        <p className="nitro-offscreen">
          <strong>6. Personal Information and Communication</strong>
        </p>{" "}
        <p className="nitro-offscreen">
          User represents that User has read understood and agreed to our
          Privacy Policy. Please note that we may disclose information about
          User to third parties or government authorities if we believe that
          such a disclosure is necessary.
        </p>{" "}
        <p className="nitro-offscreen">
          <strong>7. Electronic Communications</strong>
        </p>{" "}
        <p className="nitro-offscreen">
          User agrees that we may communicate with User by email, App
          notifications, Mobile SMS or any other form of electronic
          communication. User agrees that all communications/ documents that we
          provide to User electronically satisfy any legal requirement that such
          communications be in writing. User agrees that OB can contact User
          using above mentioned means to let User know about
        </p>{" "}
        <p className="nitro-offscreen">
          User’s job/purchase related updates, any new changes on OB Platform,
          features, promotions or other such activities which are currently or
          may be in future a part of the OB Platform. If, at any time, User
          decides that he/she does not wish to receive promotional
          communications, User can opt out of by following the instruction given
          in that particular communication.
        </p>{" "}
        <p className="nitro-offscreen">
          <strong>8. User’s Information</strong>
        </p>{" "}
        <p className="nitro-offscreen">
          User grant OB perpetual and sub-licensable right to use any
          information or material, personal or otherwise, that User provide to
          us or to other members of the OB Platform or through any e-mail or by
          way of any feature of the OB Platform for the purposes of operating
          and promoting the OB Platform in accordance with these Terms and the
          Privacy Policy. User are solely responsible for the Information
          provided, and we merely act as a passive channel for the online
          distribution and publication of the Information.
        </p>{" "}
        <p className="nitro-offscreen">
          <strong>9. User Warranties/ Representations</strong>
        </p>{" "}
        <ol className="nitro-offscreen">
          {" "}
          <li>
            By using the Application or Service, User expressly represents and
            warrants that User is legally entitled to enter this Agreement. User
            must abide by age limits defined under these Terms and User must not
            use the Application or Service. User’s participation in using the
            Service and/or Application is for User’s personal use and the use of
            others that have explicitly authorized User. User may not authorize
            others to use User’s status, and User may not assign or otherwise
            transfer User’s account to any other person or entity.
          </li>{" "}
          <li>
            User must keep his/her account credentials confidential and is
            solely responsible for maintaining the confidentiality and security
            of his/her account, all changes, updates submitted and all
            activities that occur in connection with the account.
          </li>{" "}
          <li>
            In creating an account, User represents to us that all information
            provided to us in such process is true, accurate and correct, and
            that User will update User’s information as and when necessary in
            order to keep it accurate. User agrees to provide OB with valid
            proof of identity which OB may reasonably request.
          </li>{" "}
          <li>
            User acknowledges that some of the Services on OB Platform accept
            only Credit &amp; Debit Cards (MasterCard/Visa) issued in the UAE
            and agrees that payment through this mode is mandatory for the
            completion of User’s chosen Service and related procedures.
          </li>{" "}
          <li>
            User agrees to use the data owned by OB (as available on the OB
            Platform or through any other means like API etc.) only for personal
            use/purposes and not for any commercial use unless agreed to by/with
            OB in writing.
          </li>{" "}
          <li>
            User agrees to notify us immediately of any unauthorized use of the
            account in order to enable us to take necessary corrective action.
            User also agrees that he/she will not allow any third party to use
            his/her OB account for any purpose and that User will be liable for
            such unauthorized access.
          </li>{" "}
          <li>
            User agrees that User will not engage in any activity that
            interferes with or disrupts the Services (or the servers and
            networks which are connected to the Services). User shall not: (i)
            delete or revise any Content or information posted by any other
            User(s); (ii) engage in spamming, including but not limited to any
            form of emailing, posting or messaging that is unsolicited; (iii)
            send or post infringing, obscene, threatening or other objectionable
            Content violative of third party privacy rights; (iv) send or post
            any Content containing software viruses, worms, Trojan horses or
            other harmful computer code, files, scripts, agents or programs; or
            (v) attempt to gain unauthorized access to the OB Platform or its
            related systems or networks.
          </li>{" "}
          <li>
            OB grants User a personal, limited, non-exclusive and
            non-transferable license to access and use the Services only as
            expressly permitted in these Terms. User shall not use the Services
            for any illegal purpose or in any manner inconsistent with these
            Terms. User may use information made available through the OB
            Platform solely for his/her personal, non-commercial use.
          </li>{" "}
          <li>
            User agree not to use, copy, display, distribute, modify, broadcast,
            translate, reproduce, reformat, incorporate into advertisements and
            other works, sell, promote, create derivative works, or in any way
            exploit or allow others to exploit any of the OB Platform’sContent
            in whole or in part except as expressly authorized by OB. Except as
            otherwise expressly granted to User in writing, we do not grant User
            any other express or implied right or license to the Services, OB
            Content or OB’s IP Rights. Any violation by User of the license
            provisions contained in this Section may result in the immediate
            termination of User’s right to use the Services, as well as
            potential liability for copyright and other IP Rights infringement
            depending on the circumstances.
          </li>{" "}
          <li>
            User acknowledges and agree that User are solely responsible for all
            User Content that User make available through the Service or
            Application. Accordingly, User represent and warrant that: (i) User
            either are the sole and exclusive owner of all User Content that
            User make available through the Service or Application or User have
            all rights, licenses, consents and releases that are necessary to
            grant to Company and to the rights in such User Content, as
            contemplated under these Terms; (ii) neither the User Content nor
            User’s posting, uploading, publication, submission or transmittal of
            the User Content or Company’s use of the User Content (or any
            portion thereof) on, through or by means of the Service or
            Application will infringe, misappropriate or violate a third party’s
            patent, copyright, trademark, trade secret, moral rights or other
            intellectual property rights, or rights of publicity or privacy, or
            result in the violation of any applicable law or regulation; (iii)
            Car(s), address(s), display picture or any other profile information
            posted by User belongs solely to the User or User have the full
            right to use them.
          </li>{" "}
          <li>
            We may, in our sole discretion, permit Users to post, upload,
            publish, submit or transmit User Content. By making available any
            User Content on or through the Service or Application, User hereby
            grant to Company a worldwide, irrevocable, perpetual, non-exclusive,
            transferable, royalty- free license, with the right to sublicense,
            to use, view, copy, adapt, modify, distribute, license, sell,
            transfer, publicly display, publicly perform, transmit, stream,
            broadcast and otherwise exploit such User Content only on, through
            or by means of the Service or Application. Company does not claim
            any ownership rights in any User Content and nothing in this. Terms
            will be deemed to restrict any rights that User may have to use and
            exploit any User Content.
          </li>{" "}
          <li>
            If User shares or sends any ideas, suggestions, changes or documents
            regarding OB Platform’s existing business (“Feedback”), User agree
            that (i) User’s Feedback does not contain the confidential,
            secretive or proprietary information of OB or its affiliates, (ii)
            OB is under no obligation of confidentiality with respect to such
            Feedback, and shall be free to use the Feedback on an unrestricted
            basis
          </li>{" "}
          <li>
            OB may have already received similar Feedback from some other user
            or it may be under consideration or in development, and
          </li>{" "}
          <li>
            By providing the Feedback, User grant us a non-exclusive,
            royalty-free, perpetual, global license to use, modify, develop,
            publish, distribute and sublicense the Feedback, and User
            irrevocably waive, against OB and its users any claims/assertions,
            whatsoever of any nature, with regard to such Feedback.
          </li>{" "}
          <li>
            If User’s Content is a Feedback, User represents and warranties that
            he/she is the sole author of that Feedback; the Feedback reflects an
            actual experience with Service Provider that the User had and he/she
            was not paid or otherwise remunerated in connection with User’s
            authoring or posting of the Feedback; &amp; User had no financial,
            competitive, or other personal incentive to author or post a
            Feedback that was not a fair expression of User’s honest opinion.
            User Feedback will be displayed along with user-ID on the OB
            Platform &amp; cannot be retracted once submitted. OB will not be
            responsible or liable in any way for the User Feedbacks.
          </li>{" "}
          <li>
            Notwithstanding the abovementioned clause, OB or any of its
            employees do not accept or consider unsolicited ideas, including
            ideas for new advertising campaigns, new promotions, new or improved
            products or technologies, product enhancements, processes,
            materials, marketing plans or new product names. Please do not
            submit any unsolicited ideas, original creative artwork, suggestions
            or other works (“Submissions”) in any form to OB or any of its
            employees. The purpose of this policy is to avoid potential
            misunderstandings or disputes when OB’s products or marketing
            strategies might seem similar to ideas submitted to OB. If, despite
            our request to not send us User’s ideas, User still submits them,
            then regardless of what User’s letter says, the following terms
            shall apply to User’s Submissions.{" "}
            <ul>
              {" "}
              <li>
                i. User’s Submissions and their Contents will automatically
                become the property of OB, without any compensation to User;
              </li>{" "}
              <li>
                ii. OB may use or redistribute the Submissions and their
                contents for any purpose and in any way;
              </li>{" "}
              <li>
                iii. There is no obligation for OB to review the Submission; and
              </li>{" "}
              <li>
                iv.There is no obligation to keep any Submissions confidential.
              </li>{" "}
            </ul>{" "}
          </li>{" "}
          <li>
            User shall not (i) license, sublicense, sell, resell, transfer,
            assign, distribute or otherwise commercially exploit or make
            available to any third party the Service or the Application in any
            way; (ii) modify or make derivative works based upon the Service or
            the Application; (iii) create Internet “links” to the Service or
            “frame” or “mirror” any Application on any other server or wireless
            or Internet-based device; (iv) reverse engineer or access the
            Application in order to (a) build a competitive product or service,
            (b) build a product using similar ideas, features, functions or
            graphics of the Service or Application, or (c) copy any ideas,
            features, functions or graphics of the Service or Application, or
            (v) launch an automated program or script, including, but not
            limited to, web spiders, web crawlers, web robots, web ants, web
            indexers, bots, viruses or worms, or any program which may make
            multiple server requests per second, or unduly burdens or hinders
            the operation and/or performance of the Services or OB Platform.
          </li>{" "}
          <li>
            r.User is responsible for responding to workshop queries/ estimate
            submission on time and if it is found that user is delaying the
            process of job completion by any means, then OB has the right to
            either cancel the job or charge penalties on user estimate. In cases
            where such delays by User result in the car being parked with the
            Garage for 3 or more days while waiting for User response, then a
            penalty amount of AED 25 will apply for every additional day that
            the car is parked with workshop while waiting for user’s response.
          </li>{" "}
        </ol>{" "}
        <p className="nitro-offscreen">
          <strong>10. Payment Terms</strong>
        </p>{" "}
        <ol className="nitro-offscreen">
          {" "}
          <li>
            OB Platform accepts only online payments using Visa and MasterCard
            credit/debit card issued in UAE. Currently all payments are accepted
            in AED currency only.
          </li>{" "}
          <li>
            OB Platform’s payment acceptance is integrated with CC Avenue which
            is Mashreq Bank, UAE Company &amp; is fully PCI DSS complaint. Due
            to this, any personal card related data is hosted with CC Avenue.
          </li>{" "}
          <li>
            OB is not responsible for any failure of payment due to any error in
            the CC Avenue payment gateway.
          </li>{" "}
          <li>
            OB will NOT directly deal or provide any services or products to any
            of OFAC sanctioned countries in accordance with UAE law.
          </li>{" "}
          <li>
            The total payment amount will be displayed on the App when User
            places order or upon the completion of the Job. The final payment
            shall need to be done only through OB Platform before car delivery
            or pickup from the workshop. Under no circumstances cash payments
            directly to Service Provider will be considered as a valid payment
            towards job closure. Partial payments can be done on OB Platform
            through use of any OB Credits available in User account. The
            cardholder must retain a copy of transaction records and
            product/job’s Terms and Conditions, if any.
          </li>{" "}
          <li>
            By providing the Card payment facilities, OB is merely facilitating
            the making of online payment by buyers possible, however, OB is not
            directly involved in the process of buying and selling of any
            Service or Products on the OB Platform. All sales and purchases on
            the OB Platform continue to be bipartite transactions between the
            buyer and the seller of a product/services and the final
            job/purchase invoice shall be issued by the service provider/
            seller. OB Platform is not responsible for any defects,
            non-performance, breach or any other claim relating to or arising
            out of any transaction made between any buyers and sellers, nor does
            OB Platform have any legal responsibility to the User(s).
          </li>{" "}
          <li>
            Any amount that the Company may charge User for the Services availed
            through OB Platform are due immediately and are non-refundable other
            than in circumstances in which OB considers that a refund is
            justified and User have notified OB within 72 hours of the payment
            date or the Service date, whichever falls later. In such instances
            User can notify us for through “Contact Us” link in the App or OB
            website.
          </li>{" "}
        </ol>{" "}
        <p className="nitro-offscreen">
          <strong>11. Refund &amp; Cancellation Policy</strong>
          <br /> Any refund will be done within 15 days of the complaint
          resolution and the refund amount shall be processed only through the
          original mode of payment. Refund amount shall reflect in User account
          based on banks policies.
        </p>{" "}
        <p className="nitro-offscreen">
          <strong>12. Features</strong>
        </p>{" "}
        <ol className="nitro-offscreen">
          {" "}
          <li>
            Categories &amp; Sub-Categories as defined in the OB Platform are
            based on the best judgment and discretion of OB and do not reflect
            any standard market definition of Jobs/Products.
          </li>{" "}
          <li>
            OB Platform provides market place search results basis customer’s
            preferred job/product requirements and search criteria. It is User’s
            responsibility to review all information provided about a Service
            Provider including its location before making a final decision to
            proceed.
          </li>{" "}
          <li>
            The User can make a request for pickup-drop at a workshop while
            creating a job, via OB Platform and if the workshop agrees and
            accepts to the User’s scheduled time and location then such booking
            will be confirmed to a User by email, App notification or by any
            other means of communication. Once a pick-up schedule is accepted by
            both parties, it cannot be modified any further on the OB Platform.
          </li>{" "}
          <li>
            A new job created by User on the App can be cancelled by the User
            till the time the job is not accepted by the workshop (Job in Queue
            Status). However, if the User still wants to cancel once the status
            has changes to Job In Queue, workshop is entitled to charges the
            User an Inspection or/and pickup-drop charges before
            delivering/handing over the car to the User. OB will use its best
            endeavors to keep the user informed of the status of the booking.
            This clause is not applicable to E-Shop section.
          </li>{" "}
          <li>
            The final price charged to User by the Service Provider may change
            by the time of Job Completion due to any additional services or
            consumables. Whenever, Service Provider creates/revises the
            Estimate, User shall be notified to review and approve the estimate.
            In case User wants any changes to the submitted estimate, he has the
            option to resend the estimate for revision. In case even after
            multiple such revisions, User doesn’t agree on the Estimate, he/she
            has the option to reject the estimate. This will effectively cancel
            the job and user shall be needed to pay any inspection/pickup-drop
            charges that may be applied by the Service Provider. This clause is
            not applicable to E-Shop section.
          </li>{" "}
          <li>
            OB Messaging Tool is an informal medium of communication between the
            Service Provider and User meant to bring in transparency. Under no
            circumstances the messages or pictures shared through this medium
            will be legally binding on any party related to the OB Platform. OB
            may store your messages in order to review them and investigate
            possible violations, if any of our Terms and wrong doing in
            connection with the Services/Terms.
          </li>{" "}
          <li>
            OB Credits program is solely run by OB. OB in its sole discretion
            can change the earn or burn rate of the credit that a User can earn
            or has already earn in his OB Credit’s Pool. OB Credits have a
            validity period of 36 months from the date of accrual. After which
            any un-utilized point may be wiped-off from User’s Credit Pool.
          </li>{" "}
          <li>
            OB Credits shall be given on successfully completed jobs/purchases.
          </li>{" "}
          <li>
            Packages are a bundling of the services by the Service Providers and
            it is solely the User’s responsibility to review and verify the
            Terms and Conditions of the package before buying including the
            expiry date and number of uses/redemptions (if any).
          </li>{" "}
          <li>
            Car Tools and Calculators are meant to assist Users and their
            accuracy and reliability are not guaranteed in any way by OB. OB
            disclaims any liability arising out of the inaccuracy or failure of
            tools and calculators on OB Platform.
          </li>{" "}
          <li>
            The Parking Assistant tool is car parking scheduler which uses
            User’s mobile SMS functionality. Normal SMS rates may as per User’s
            telecom provider’s tariff.
          </li>{" "}
          <li>
            Catalogue listings are similar to classified listings of services
            that are expected to be handy for any car owner. OB takes no
            responsibility of verifying the catalogue listings and User
            acknowledges that upon showing interest on any catalogue listing,
            User’s contact details (name email, contact number) may be shared
            with the respective Service Provider.
          </li>{" "}
          <li>
            The articles/blogs/news posted under Open-Up section are the sole
            opinion of the author. OB disclaims all the liabilities arising out
            of any disputes or disagreements with the posted content.
          </li>{" "}
          <li>
            OB Price Point Rating is an expected average cost of standardized
            jobs when performed across various Service Providers. This is
            derived basis an internal logic and is merely for indicative
            purposes. OB does not take any guarantee of its accuracy or
            reliability – both of which are recommended to be verified by the
            User before basing any decision on the rating provided on OB
            Platform.
          </li>{" "}
          <li>
            User acknowledges that he/she will verify whether the accessories
            purchased on OB Platform is coming with installation support or
            needs to be fixed at User’s end. User should also make sure that the
            location of the installation center is as per User’s convenience.
          </li>{" "}
          <li>
            User agrees to provide a valid ID for the redemption of the packages
            or the installation of the accessories, when requested by the
            Service Provider.
          </li>{" "}
        </ol>{" "}
        <p className="nitro-offscreen">
          <strong>13. Copyright &amp; Trademarks</strong>
          <br /> Company respects copyright law and expects its users to do the
          same. It is Company’s policy to terminate in appropriate circumstances
          Users or other account holders who repeatedly infringe or are believed
          to be repeatedly infringing the rights of copyright holders.
        </p>{" "}
        <p className="nitro-offscreen">
          <strong>14. Ownership of OB Content and Proprietary Rights</strong>
        </p>{" "}
        <p className="nitro-offscreen">
          a. OB is the sole and exclusive copyright owner of the Services and OB
          Content. OB also exclusively owns the trademarks, logos, trade names
          and other intellectual and proprietary rights (the “IP Rights”)
          associated with the Services, OB Content and Third Party Content which
          may be protected by applicable intellectual property and proprietary
          rights and laws.
        </p>{" "}
        <p className="nitro-offscreen">
          b. User acknowledges that the Services, OB Content and Third Party
          Content may contain original works and have been developed, revised
          and arranged by OB through the expenditure of time, effort, money and
          constitutes valuable intellectual property of OB. User further
          acknowledges that the Services may contain information which is
          designated as confidential by OB or its affiliates and that User shall
          not use, modify or disclose such information without OB’s prior
          written consent. Unless User has agreed otherwise in writing with OB,
          nothing in the Terms gives User a right to use any of OB’s IP rights.
        </p>{" "}
        <p className="nitro-offscreen">
          c. User agrees to protect OB &amp; its affiliate’s proprietary rights
          in the Services during and after the term of this agreement and to
          comply with all reasonable written requests made by us or our
          affiliates to protect their and others’ contractual, statutory, and
          common law rights in the Services. User acknowledges and agrees that
          OB owns all legal rights, titles and interest in and to the Services,
          including any IP Rights which subsist in the Services (whether those
          rights happen to be registered or not, and wherever in the world those
          rights may exist).
        </p>{" "}
        <p className="nitro-offscreen">
          d. Any infringement shall lead to appropriate legal proceedings
          against User at appropriate forum for seeking all available/possible
          remedies under applicable laws of UAE or country of violation as
          deemed fit.
        </p>{" "}
        <p className="nitro-offscreen">
          e. To the fullest extent permitted by applicable law, OB neither
          warrants nor represents that use of information displayed on the
          Services by User will not infringe rights of third parties not owned
          by or affiliated with OB. User agrees to immediately notify OB upon
          becoming aware of any claim that the Services infringe upon any
          copyright trademark, or other contractual, intellectual, statutory, or
          common law rights.
        </p>{" "}
        <p className="nitro-offscreen">
          <strong>15. Indemnification</strong>
        </p>{" "}
        <p className="nitro-offscreen">
          a. User agrees to indemnify &amp; hold harmless OB and its officers/
          representatives from any third party claims, damages (actual and/or
          consequential), actions, proceedings, demands, losses, liabilities,
          costs and expenses (including reasonable legal fees) suffered by User
          or User’s car arising as a result of, or in connection with: (i) the
          Content, (ii) use or access of the Services, (iv) User’s violation
          ofany rights of another party; or (v) User’s breach of these Terms or
          infringement of the copyright or intellectual property rights of any
          third party. This indemnity to OB shall apply whether or not OB has
          been advised of the possibility of such losses or damages.
        </p>{" "}
        <p className="nitro-offscreen">
          b. In the case of disputes arising due to poor quality of service, or
          in the case of damage being done to a users’ whilst its job or product
          is in the possession of a the selected Service Provider, it is the
          sole responsibility of the selected workshop to make good the damage
          and or repair.
        </p>{" "}
        <p className="nitro-offscreen">
          c. OB retains the exclusive right to settle at User’s expense and
          without User’s prior consent, any claims or causes of action which are
          brought against OB and User agrees to cooperate with our defense of
          these claims. User agrees not to settle any matter in which OB is
          named as a defendant and/or for which User has indemnity obligations
          without OB’s prior written consent. OB will use reasonable efforts to
          notify User of any such claim, action or proceeding upon becoming
          aware of it.
        </p>{" "}
        <p className="nitro-offscreen">
          d. User Feedbacks or ratings for Workshops do not reflect the opinion
          of OB. OB receives multiple Feedbacks or ratings for Workshops by
          Users, which reflect the opinions of the Users. It is pertinent to
          state that each and every Feedback posted on OB is the personal
          opinion of the User only. OB is a neutral platform, which solely
          provides a means of communication between Users and workshop
          owners/representatives with access to workshop business partner panel.
          However, User acknowledges and agrees that User may not include links
          in any content that User posts on the OB Platform. Any Feedback, which
          is derogatory, defamatory or hateful or in violation of the Guidelines
          and Polices and without any substantial evidence may be taken down at
          OB’s sole discretion.
        </p>{" "}
        <p className="nitro-offscreen">
          e. OB is constantly evolving in order to provide the best possible
          experience and information to its users. User acknowledges and agrees
          that the form and nature of the Services which OB provides, may
          require effecting certain changes in it, therefore, OB reserves the
          right to suspend/cancel, or discontinue any or all products or
          services at any time without notice, make modifications and
          alterations in any or all of its contents, products and services
          contained on the site without any prior notice.
        </p>{" "}
        <p className="nitro-offscreen">
          f. For availing the latest updates in OB Platform, User may be
          required to install certain upgrades or updates to the software in
          order to continue to access or use the Services, or portions thereof
          (including upgrades or updates designed to correct issues with the
          Services). Any updates or upgrades provided to User by OB under the
          Terms shall be considered part of the Services. OB disclaims any
          liability for any information that may have become outdated since the
          last time the particular piece of information was updated and we shall
          not be liable for any delay or inaccuracies related to such updates.
          OB reserves the right to make changes and corrections to any part of
          the Content on these Services at any time without prior notice.
        </p>{" "}
        <p className="nitro-offscreen">
          g. The information and pictures describing products, services and
          their prices on the App are listed by the Service Providers directly
          and OB does not take any guarantee of the accuracy or quality of such
          services, products and neither does OB have any control or say in the
          listed prices. OB disclaims any liability arising out of the
          inaccuracy of all such Content.
        </p>{" "}
        <p className="nitro-offscreen">
          h. Unless stated otherwise, all pictures and information contained on
          these Services are believed to be owned by Service Providers and
          licensed to be used on OB Platform.
        </p>{" "}
        <p className="nitro-offscreen">
          i. OB may from time to time run promotions/offers on OB platform for
          its Users. These promotions/offer maybe governed by their respective
          Terms and Conditions which will be informed at the time of
          promotion/offer launch and Users are fully bound by them.
        </p>{" "}
        <p className="nitro-offscreen">
          j. We may obtain business addresses, phone numbers, and other contact
          information from third party vendors who obtain their data from public
          sources. We do not screen or investigate third party material before
          or after including it on our Services.
        </p>{" "}
        <p className="nitro-offscreen">
          k. Further, OB reserves the right to terminate/suspend the User’s
          accrued loyalty points or the fresh accrual of points in User’s
          loyalty account if OB determines in its sole discretion that the User
          has violated the Terms and Conditions of the promotion/ offer and/or
          OB Platform Terms. Furthermore, OB reserves the right to modify,
          cancel and discontinue the promotions/offers without notice to the
          User.
        </p>{" "}
        <p className="nitro-offscreen">
          l. OB Platform’s payment acceptance is integrated with CC Avenue which
          is Mashreq Bank, UAE Company &amp; is fully PCI DSS complaint. Due to
          this, any personal card related data is hosted with CC Avenue.
        </p>{" "}
        <p className="nitro-offscreen">
          m. User agrees that OB is not responsible for any fraudulent card
          usage or card data theft arising out of errors at the end of CC Avenue
          and that all claims for any such incidents shall be directly managed
          by CC Avenue.
        </p>{" "}
        <p className="nitro-offscreen">
          n. OB makes no representations that the operation of the OB Platform
          will be error-free and/or uninterrupted. OB makes no warranty that
          defects will be corrected or that the OB Platform or its servers are
          free of viruses or anything else which may be harmful ordestructive.
          The nature of Internet communications means that OB Platform may be
          susceptible to data corruption, interception, non-availability and
          delays. The OB Platform may also be unavailable from time to time due
          to repairs, maintenance or development work. User agrees that OB has
          no obligation to provide support for the OB Platform and that the User
          is accessing it at User’s own risk.
        </p>{" "}
        <p className="nitro-offscreen">
          o. If User is dissatisfied with the Site or any content or materials
          on it, User’s sole exclusive remedy is to discontinue its use.
        </p>{" "}
        <p className="nitro-offscreen">
          p. None of the provisions of this User Agreement shall be deemed to
          constitute a partnership or agency between User and OB and User shall
          have no authority to bind OB in any manner whatsoever.
        </p>{" "}
        <p className="nitro-offscreen">
          q. Except as explicitly stated otherwise, any notices to OB from User
          shall be given by User through email to OB at customer@openbonnet.com,
          such notice is deemed given on confirmation of its receipt to User by
          OB through return email. Any notices to Users from OB shall be given
          by notifications on OB Platform or by email to the email address User
          provided to OB during the registration process and shall be deemed to
          be received by User 48 hours after any such email is sent.
        </p>{" "}
        <p className="nitro-offscreen">
          r. It is the sole responsibility of the User to enquire as to the
          warranty given on any particular service or product sourced through
          the website. Most provisions of Services &amp; Sales in the UAE are
          guaranteed by the department of economic development for a period of
          30 days however, OB is in no way responsible for the enforcement of
          this or any other extended warranty and it is the Users’ sole
          responsibility to check with Service Provider that Services &amp;
          products procured are being offered with a standard or extended
          warranty.
        </p>{" "}
        <p className="nitro-offscreen">
          s. During use of the Application and Service, User may enter into
          correspondence with, purchase goods and/or Services from, or
          participate in promotions of third party service providers showing
          their goods and/or services through the Application or Service. Any
          such activity, and any terms, conditions, warranties or
          representations associated with such activity, are solely between User
          and the applicable third-party. OB shall have no liability, obligation
          or responsibility for any such correspondence, purchase, transaction
          or promotion between User and any such third-party.
        </p>{" "}
        <p className="nitro-offscreen">
          t. OB does not endorse any sites on the internet that are linked
          through the Service or Application, and in no event shall OB or its
          licensors be responsible for any content, products, services or other
          materials on or available from such sites or third party providers.
        </p>{" "}
        <p className="nitro-offscreen">
          u. The Company provides the Application and Service to User pursuant
          to the acceptance of these Terms. User recognizes, however, that
          certain third-party providers of goods and/or services may require
          User’s agreement to additional or different terms and conditions prior
          to User’s use of or access to such goods or services, and OB disclaims
          any and all responsibility or liability arising from such agreements
          between User and the third party providers or from the non-performance
          of the agreed Services.
        </p>{" "}
        <p className="nitro-offscreen">
          v. Notwithstanding anything otherwise set out herein, OB shall in no
          manner be liable in any way for any in-person interactions with the
          Service Provider as a result of the booking or for the User’s
          experience at the workshop or in the event a Service Provider does not
          honor a confirmed booking.
        </p>{" "}
        <p className="nitro-offscreen">
          w. Member Get Member Promotion: Periodically, OB may introduce rewards
          for any existing app user who recommends OB and gets new customers
          create a new OB account and/or does 1st transaction. The maximum
          points that the ‘recommender’ can get under these promotions will be
          equal to the sum total for up to 5 new members introduced by him/ her
          as per the other T&amp;Cs that may be informed along with the
          promotion.
        </p>{" "}
        <p className="nitro-offscreen">
          <strong>16. Governing Law &amp; Disputes</strong>
          <br /> a. This User Agreement is governed by, and construed in
          accordance with, UAE law.
          <br /> b. There is a three (3) days dispute claim period – both for
          jobs as well as e-shop purchases.
          <br /> c. Any dispute raised within this period shall be resolved
          amicably. However in case of failure to amicably solve the issue, the
          Dubai Courts shall have jurisdiction.
          <br /> d. Any dispute, claim or controversy arising out of or in
          connection with this Agreement, including a dispute, claim or
          controversy arising in relation to its interpretation or relating to
          any non-contractual obligations arising out of or in connection with
          this agreement (a “Dispute”) shall be settled amicably between the
          parties following the receipt by either party of written notice of the
          Dispute from the other party. In the event that a Dispute cannot be
          settled amicably within a period of 60 days from the date on which the
          relevant party notifies the other in writing that a Dispute has
          arisen, the parties agree that such Dispute shall be referred to and
          finally settled by arbitration under the DIFC-LCIA Arbitration Rules,
          which Rules are deemed to be incorporated by reference into this
          Agreement. The seat, or legal place, of arbitration shall be the DIFC.
          <br /> e. The number of arbitrators shall be three. Each party will
          nominate one arbitrator for appointment by the LCIA Court. The third
          arbitrator, who shall act as chairman, shall jointly be nominated by
          the other arbitrators so nominated and appointed by the LCIA Court.
          <br /> f. The language to be used in the arbitration shall be English.
          <br /> g. The award made by the arbitrator shall be final and binding
          on the parties and may be enforced in any court of competent
          jurisdiction. To the extent permissible by law, the parties hereby
          waive any right to appeal against the decision of the arbitrator.
          <br /> h. This “Dispute Resolution” section will survive any
          termination of this Agreement.
        </p>{" "}
        <p className="nitro-offscreen">
          <strong>17. IP Rights and Transfer of Information</strong>
          <br /> a. The Company alone (and its licensors, where applicable)
          shall own all right, title and interest, including all related
          intellectual property rights, in and to the Application and the
          Service and any suggestions, ideas, enhancement requests, feedback,
          recommendations or other information provided by you or any other
          party relating to the Application or the Service. This Agreement is
          not a sale and does not convey to you any rights of ownership in or
          related to the Application or the Service, or any intellectual
          property rights owned by the Company. The Company name, the Company
          logo, and the product names associated with the Application and
          Service are trademarks of the Company or third parties, and no right
          or license is granted to use them.
          <br /> b. By submitting User’s Content User hereby irrevocably grants
          OB a perpetual, irrevocable, royalty-free, sub-licensable and
          transferable license and right to use User Content and all IP Rights
          therein for any purpose including mergers, acquisitions, third-party
          partnerships and in any media existing now or in future. By “use” it’s
          meant to use, copy, display, distribute, modify, translate, reformat,
          incorporate into advertisements and other works, promote, create
          derivative works, and in the case of third party services, allow their
          users and others to do the same. User grants us the right to use the
          name or username that you submit in connection with User Content. User
          irrevocably waives any claims and assertions of moral rights or
          attribution with respect to User Content brought against OB, OB
          Representatives, OB Affiliates, OB Users, any third party services and
          their users.
        </p>{" "}
        <p className="nitro-offscreen">
          <strong>17. Amendments to Terms of Service</strong>
          <br /> OB may amend or update these Terms, from time to time entirely
          at its own discretion. User shall be responsible for checking these
          Terms on the App and ensure continued compliance with these Terms.
          User’s use of OB Platform after any such amendment in the Terms shall
          be deemed as his/her acceptance to be bound by such amended Terms.
        </p>{" "}
        <p className="nitro-offscreen">
          <strong>
            For any queries related to these Terms of Service, please contact us
            on: user@openbonnet.com
          </strong>
        </p>
      </Container>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    profile: state.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Terms);
